import React from 'react';
import './DivisionListContainer.scss';
import DivisionDataTable from './DivisionDataTable';

export const QA_ID_PREFIX = 'DivisionListContainer';

function DivisionListContainer({ selectedFilter, setShowFilterEditModal, setShowRecipientDownloadModal, downloadInProgress, onDownload }) {
  return (
    <DivisionDataTable
      selectedFilter={selectedFilter}
      qaPrefix={QA_ID_PREFIX}
      itemsPerPageDefault={8}
      className="division-list-container"
      setShowFilterEditModal={setShowFilterEditModal}
      setShowRecipientDownloadModal={setShowRecipientDownloadModal}
      downloadInProgress={downloadInProgress}
      onDownload={onDownload}
    />
  );
}

export default DivisionListContainer;
